import * as api from 'api/methods';

import { showToast } from 'helpers/showToast';
import { getTranslation } from 'helpers/getTranslation';
import { getUnknownErrorMessage } from 'helpers/unknownErrorMessage';

import { getFigmaFileImages } from './getFigmaFileImages';
import { getTasksMaterials } from './getTasksMaterials';
import { getDesignInitialState } from './getDesignInitialState';
import { getDesignTasks } from './getDesignTasks';
import { getPrototypeInitialState } from './getPrototypeInitialState';
import { getPrototypeTasks } from './getPrototypeTasks';

const _getFileDesignType = (filePage: any) => {
  const type = filePage.name.split(':')[0];

  if (type === 'Design') {
    return 'DESIGN';
  }

  if (type === 'Prototype') {
    return 'PROTOTYPE';
  }

  return null;
};

export const getResyncData = async ({
  fileId,
  filePageId,
  currentInitialState,
  currentTasks,
  designType,
}: {
  fileId: string;
  filePageId: string;
  currentInitialState: any;
  currentTasks: any;
  designType: any;
}) => {
  try {
    const file = await api.getFigmaFile(fileId);
    const fileImages = await getFigmaFileImages(fileId);

    const filePage = file.document.children.find(
      (page: any) => page.id === filePageId,
    );

    const fileDesignType = _getFileDesignType(filePage);

    if (designType && fileDesignType !== designType) {
      showToast({
        data: {
          variant: 'error',
          title: 'Error!',
          text: 'Design type is not the same',
        },
      });

      return null;
    }

    switch (fileDesignType) {
      case 'DESIGN': {
        const { initialState } = await getDesignInitialState({
          fileId,
          filePage,
          currentInitialState,
        });

        if (!initialState) {
          showToast({
            data: {
              variant: 'error',
              title: 'Error!',
              text: 'No initial state error',
            },
          });

          return null;
        }

        const tasks = await getDesignTasks({
          fileId,
          filePage,
          fileImages,
          currentTasks,
        });

        if (!tasks || tasks.length === 0) {
          showToast({
            data: {
              variant: 'error',
              title: 'Error!',
              text: 'No tasks error',
            },
          });

          return null;
        }

        return [
          tasks,
          initialState,
          fileDesignType,
          getTasksMaterials({ fileImages, tasks, initialState }),
        ];
      }
      case 'PROTOTYPE': {
        const initialState = getPrototypeInitialState({
          filePage,
          currentInitialState,
        });

        const tasks = getPrototypeTasks({ filePage, currentTasks });

        return [
          tasks,
          initialState,
          fileDesignType,
          getTasksMaterials({ fileImages, tasks, initialState }),
        ];
      }
    }
  } catch (error) {
    console.warn(error);

    showToast({
      data: {
        variant: 'error',
        title: getTranslation('common.toast.error.title'),
        text: getUnknownErrorMessage(
          error,
          getTranslation('common.toast.error.text'),
        ),
      },
    });
  }

  return null;
};
